import apiService from './apiService';

// Notify Isolation
export const notifyIsolation = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/notify-isolation`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying isolation:', error);
    throw error;
  }
};

// Add Instruction
export const addInstruction = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/add-instruction`, payload);
    return response.data;
  } catch (error) {
    console.error('Error adding instruction:', error);
    throw error;
  }
};

// Mark Isolation
export const markIsolation = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-isolation`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking isolation:', error);
    throw error;
  }
};

// Notify Issue Permit
export const notifyIssuePermit = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/notify-issue-permit`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying issue permit:', error);
    throw error;
  }
};

// Mark Issue Permit
export const markIssuePermit = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-issue-permit`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking issue permit:', error);
    throw error;
  }
};

// Mark Permit Take Out
export const markPermitTakeOut = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-permit-takeout`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking permit take out:', error);
    throw error;
  }
};

// Mark RP Suspended
export const markRPSuspended = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-rp-suspended`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking RP suspended:', error);
    throw error;
  }
};

// Notify AOC Suspend
export const notifyAOCSuspend = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/notify-aoc-suspend`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying AOC suspend:', error);
    throw error;
  }
};

// Mark AOC Suspended
export const markAOCSuspended = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-aoc-suspended`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking AOC suspended:', error);
    throw error;
  }
};

// Add Test Sanction
export const addTestSanction = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/add-test-sanction`, payload);
    return response.data;
  } catch (error) {
    console.error('Error adding test sanction:', error);
    throw error;
  }
};

// Edit Test Sanction before it is submitted for signing
export const updateTestSanction = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.put(`/lv-work-permits/${permitId}/edit-test-sanction`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating test sanction:', error);
    throw error;
  }
};

// Reject Test Sanction
export const rejectTestSanction = async (permitId: string | number, payload: { remarks: string }) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/reject-test-sanction`, payload);
    return response.data;
  } catch (error) {
    console.error('Error rejecting test sanction:', error);
    throw error;
  }
};

// Notify AOC Sign
export const notifyAOCSign = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/notify-aoc-sign`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying AOC sign:', error);
    throw error;
  }
};

// Mark AOC Signed
export const markAOCSigned = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-aoc-signed`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking AOC signed:', error);
    throw error;
  }
};

// Mark RP Signed
export const markRPSigned = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-rp-signed`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking RP signed:', error);
    throw error;
  }
};

// Mark Work Complete
export const markWorkComplete = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-work-complete`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking work complete:', error);
    throw error;
  }
};

// Notify SFT Revoke
export const notifySFTRevoke = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/notify-sft-revoke`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying SFT revoke:', error);
    throw error;
  }
};

// Mark SFT Revoked
export const markSFTRevoked = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-sft-revoked`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking SFT revoked:', error);
    throw error;
  }
};

// Mark RP Revoked
export const markRPRevoked = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-rp-revoked`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking RP revoked:', error);
    throw error;
  }
};

// Notify AOC Revoke
export const notifyAOCRevoke = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/notify-aoc-revoke`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying AOC revoke:', error);
    throw error;
  }
};

// Mark AOC Revoked
export const markAOCRevoked = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-aoc-revoked`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking AOC revoked:', error);
    throw error;
  }
};

// Mark RP Clearance
export const markRPClearance = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-rp-cleared`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking RP clearance:', error);
    throw error;
  }
};

// Notify AOC Clearance
export const notifyAOClearance = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/notify-aoc-clearance`, payload);
    return response.data;
  } catch (error) {
    console.error('Error notifying AOC clearance:', error);
    throw error;
  }
};

// Mark AOC Clearance
export const markAOClearance = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-aoc-cleared`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking AOC clearance:', error);
    throw error;
  }
};

// Mark Received
export const markReceived = async (permitId: string | number, payload: Record<string, any> = {}) => {
  try {
    const response = await apiService.post(`/lv-work-permits/${permitId}/mark-received`, payload);
    return response.data;
  } catch (error) {
    console.error('Error marking received:', error);
    throw error;
  }
};

// Get LVWP Isolation Status
export const getLvwpIsolationStatus = async () => {
  try {
    const response = await apiService.get('/LvwpIsolationStatus');
    return response.data;
  } catch (error) {
    console.error('Error fetching isolation statuses:', error);
    throw error;
  }
};

// Get LVWP Substation Keys
export const getLvwpSubstationKeys = async () => {
  try {
    const response = await apiService.get('/LvwpSubstationKeys');
    return response.data;
  } catch (error) {
    console.error('Error fetching substation keys:', error);
    throw error;
  }
};
// ================= LV WORK PERMIT WORKFLOW - INSTRUCTION APIs =================
export const editInstruction = async (permitId: string | number, payload: Record<string, any>) => {
  try {
    const response = await apiService.put(`/lv-work-permits/${permitId}/edit-instruction`, payload);
    return response.data;
  } catch (error) {
    console.error('Error editing instruction:', error);
    throw error;
  }
};

export const deleteInstruction = async (permitId: string | number) => {
  try {
    const response = await apiService.delete(`/lv-work-permits/${permitId}/delete-instruction`);
    return response.data;
  } catch (error) {
    console.error('Error deleting instruction:', error);
    throw error;
  }
};
